import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export { gsap, ScrollTrigger };

// Animate any element with .reveal-up children -> stagger up
export function revealUp(scope, selector = ".reveal-up", opts = {}) {
  const els = scope.querySelectorAll(selector);
  if (!els.length) return;
  return gsap.to(els, {
    y: 0,
    opacity: 1,
    duration: 1.1,
    ease: "power3.out",
    stagger: 0.08,
    scrollTrigger: {
      trigger: scope,
      start: "top 80%",
    },
    ...opts,
  });
}

// Animate counters
export function counterTo(el, target, duration = 2) {
  const obj = { v: 0 };
  return gsap.to(obj, {
    v: target,
    duration,
    ease: "power2.out",
    scrollTrigger: { trigger: el, start: "top 85%" },
    onUpdate: () => {
      el.textContent = Math.round(obj.v).toLocaleString();
    },
  });
}

// Hero text split-line reveal
export function lineReveal(el, delay = 0) {
  const spans = el.querySelectorAll(".split-line > span");
  return gsap.to(spans, {
    y: 0,
    duration: 1.1,
    ease: "power4.out",
    stagger: 0.08,
    delay,
  });
}
